import { connect } from 'react-redux'
import {
  compose,
  graphql,
} from 'react-apollo'
import { getAllNodesQuery } from '../queries'
import {
  deleteNodeMutation,
  updateListMutation,
  updateOptionMutation,
  updateOptionGroupMutation,
  updateRootMutation,
  uploadImageMutation,
} from '../mutations'
import { getActiveNode } from '../selectors'
import { setActiveNode } from '../actions'
import AdminNodeDetail from '../components/adminNodeDetail'

const getOptions = nodes => nodes && Array.isArray(nodes) && nodes.filter(node => node.nodeType === 'OptionGroup').map(node => ({
  id: node.id,
  title: `${nodes.find(parent => parent.id === node.parent).title} - ${node.title}`,
}))

const mapStateToProps = (state, ownProps) => ({
  node: getActiveNode({
    state,
    nodes: ownProps.nodes,
  }),
  options: getOptions(ownProps.nodes),
  config: {
    List: {
      fields: [
        'title',
        'description',
        'images',
        'isVisible',
        'maxSelect',
        'minSelect',
      ],
      variables: (id, changes) => ({
        list: {
          id,
          ...changes,
        },
      }),
    },
    Option: {
      fields: [
        'title',
        'description',
        'conflicts',
        'images',
        'isVisible',
        'price',
        'pricePerArea',
        'requires',
      ],
      variables: (id, changes) => ({
        option: {
          id,
          ...changes,
        },
      }),
    },
    OptionGroup: {
      fields: [
        'area',
        'title',
        'elements',
        'isVisible',
        'price',
        'rooms',
      ],
      variables: (id, changes) => ({
        optionGroup: {
          id,
          ...changes,
        },
      }),
    },
    Root: {
      fields: [
        'maxSelect',
        'minSelect',
      ],
      variables: (id, changes) => ({
        root: {
          id,
          ...changes,
        },
      }),
    },
  },
})

const mapDispatchToProps = dispatch => ({
  setActive: nodeId => dispatch(setActiveNode(nodeId)),
})

export default compose(
  graphql(deleteNodeMutation, {
    name: 'deleteNodeMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(updateListMutation, {
    name: 'updateListMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(updateOptionMutation, {
    name: 'updateOptionMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(updateOptionGroupMutation, {
    name: 'updateOptionGroupMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(updateRootMutation, {
    name: 'updateRootMutation',
    options: {
      refetchQueries: [{
        query: getAllNodesQuery,
      }],
    },
  }),
  graphql(uploadImageMutation, {
    name: 'uploadImageMutation',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AdminNodeDetail)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminNodeDetail.js